import { SharedCheckLocationI } from "src/app/api/shared-check-location/shared-check-location.result.int";
import { SharedCheckLocationQueryI } from "src/app/api/shared-check-location/shared-check-location.query.int";
import { createActionGroup } from "@ngrx/store";
import { spxCreateApiActions } from "@softpak/components/spx-redux";

export const SharedCheckLocationActions = createActionGroup({
  source: 'SharedCheckLocation',
  events: {
    ...spxCreateApiActions<SharedCheckLocationQueryI, SharedCheckLocationI>(),
  },
});
